import { render, staticRenderFns } from "./NormalSearchNav77.vue?vue&type=template&id=4523863a&scoped=true"
import script from "./NormalSearchNav77.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav77.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4523863a",
  null
  
)

export default component.exports